import {RenderUtil} from "../RenderUtil";
import {Point} from "../../Point";

export class PictogramRenderer {
  constructor() {
    this.color = 'Black'
    this.color2 = 'White'
    this.withOutline = false
  }

  drawBlazePose(ctx, points, hands) {
    const dist = Point.dist(points[7], points[8])
    const color = this.color
    const color2 = this.color2
    const outLineWidth = dist * 0.1

    if (this.withOutline) {
      ctx.strokeStyle = color2
      ctx.lineWidth = outLineWidth
    }
    ctx.fillStyle = color
    const headSize = Math.max(1.1 * dist, 90)
    // this.drawCircle(ctx, points[0], 1.1 * dist)
    this.drawCircle(ctx, points[0], headSize)
    ctx.fill()

    RenderUtil.drawPolygon(ctx, [points[11], points[12], points[24], points[23]], color)

    ctx.lineCap = 'round'

    // const armLineWidth = dist * 0.65
    const armLineWidth = Math.max( dist * 0.65, 63)
    this.drawLineWithOutline(ctx, points[11], points[13], armLineWidth, outLineWidth)
    this.drawLineWithOutline(ctx, points[13], points[15], armLineWidth, outLineWidth)
    if (!hands) {
      this.drawLineWithOutline(ctx, points[15], points[19], armLineWidth, outLineWidth)
    }
    // this.drawLine(ctx, points[11], points[13], lineWidth, outLineWidth)
    // this.drawLine(ctx, points[13], points[15], lineWidth, outLineWidth)

    this.drawLineWithOutline(ctx, points[12], points[14], armLineWidth, outLineWidth)
    this.drawLineWithOutline(ctx, points[14], points[16], armLineWidth, outLineWidth)
    if (!hands) {
      this.drawLineWithOutline(ctx, points[16], points[20], armLineWidth, outLineWidth)
    }
    // this.drawLine(ctx, points[12], points[14], lineWidth, outLineWidth)
    // this.drawLine(ctx, points[14], points[16], lineWidth, outLineWidth)

    this.drawLineWithOutline(ctx, points[12], points[11], armLineWidth, outLineWidth)

    // const legLineWidth = dist * 0.8
    const legLineWidth = Math.max( dist * 0.8, 80)
    this.drawLineWithOutline(ctx, points[23], points[25], legLineWidth, outLineWidth)
    this.drawLineWithOutline(ctx, points[25], points[27], legLineWidth, outLineWidth)
    this.drawLineWithOutline(ctx, points[27], points[31], legLineWidth, outLineWidth)

    this.drawLineWithOutline(ctx, points[24], points[26], legLineWidth, outLineWidth)
    this.drawLineWithOutline(ctx, points[26], points[28], legLineWidth, outLineWidth)
    this.drawLineWithOutline(ctx, points[28], points[32], legLineWidth, outLineWidth)

    this.drawLineWithOutline(ctx, points[23], points[24], legLineWidth, outLineWidth)

    // const lineWidth2 = dist * 0.3
    const lineWidth2 = Math.max(dist * 0.3, 70)
    this.drawLineWithOutline(ctx, points[11], points[23], lineWidth2, outLineWidth)
    this.drawLineWithOutline(ctx, points[12], points[24], lineWidth2, outLineWidth)

    if (hands) {
      hands.forEach(hand => this.drawFigureHand(ctx, hand.keypoints))
    }
  }

  drawFigureHand(ctx, points) {
    const nodePairs = [
      [0,5], [5,9], [9,13], [13,17], [0,17],
      [5,6],[6,7],[7,8],
      [9,10],[10,11],[11,12],
      [13,14],[14,15],[15,16],
      [17,18],[18,19],[19,20],
      [0,1],[1,2],[2,3],[3,4]
    ]
    nodePairs.forEach(pair => {
      this.drawLine(ctx, points[pair[0]], points[pair[1]])
    })

    ctx.fillStyle = 'Black'
    ctx.beginPath();
    ctx.moveTo(points[5].x, points[5].y)
    ctx.lineTo(points[9].x, points[9].y)
    ctx.lineTo(points[13].x, points[13].y)
    ctx.lineTo(points[17].x, points[17].y)
    ctx.lineTo(points[0].x, points[0].y)
    ctx.lineTo(points[2].x, points[2].y)
    ctx.lineTo(points[5].x, points[5].y)
    // ctx.stroke()
    ctx.fill()
  }

  drawCircle(ctx, pos, size) {
    ctx.beginPath();
    ctx.arc(pos.x, pos.y, size, 0, Math.PI * 2, true);
    ctx.stroke();
  }

  drawLine(ctx, p1, p2, width, outLineWidth) {
    ctx.lineWidth = width
    ctx.strokeStyle = this.color
    RenderUtil.drawLine(ctx, p1, p2)
  }

  drawLineWithOutline(ctx, p1, p2, width, outLineWidth) {
    if (this.withOutline) {
      ctx.lineWidth = width + outLineWidth
      ctx.strokeStyle = this.color2
      RenderUtil.drawLine(ctx, p1, p2)
    }

    ctx.lineWidth = width
    ctx.strokeStyle = this.color
    RenderUtil.drawLine(ctx, p1, p2)
  }

  drawDumbbell(ctx, points) {
    ctx.lineWidth = 60
    const p1 = new Point(points[4]).add(new Point(points[20]).delta(points[4]).multiply(2))
    const p2 = new Point(points[20]).add(new Point(points[4]).delta(points[20]).multiply(2))
    this.drawCircle(ctx, p1, 60)
    ctx.fill()
    this.drawCircle(ctx, p2, 60)
    ctx.fill()
    RenderUtil.drawLine(ctx, p1, p2)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/renderer/PictogramRenderer.js